import axios            from 'axios';
import authHeaderBearer from 'services/auth-header-bearer';
import drIds            from 'services/dr-ids';
import drIdsHashed      from 'services/dr-ids-hashed';

const docParam = drIdsHashed();

class GuaranteeLetterService  {
  list(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters?' + parameters + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  // Need show to retrieve doctor_upload_documents. Index does not seem to retrieve it.
  show(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters/' + id + '?' + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  insuranceList(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/insurances?' + parameters + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  createGuaranteeLetter(parameters) {
    var dataParams            = parameters;
    dataParams.eb_doctor_id   = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters', dataParams, { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  updateGuaranteeLetter(parameters, id) {
    var dataParams = parameters;
    dataParams.append('eb_doctor_id', docParam.doctor_id);
    dataParams.append('eb_location_id', docParam.location_id);

    return axios
      .patch(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters/' + id, dataParams, { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  deleteGuaranteeLetter(id) {
    return axios
      .delete(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters/' + id + '?' + drIds(), { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }

  requestFinal(id, parameters) {
    var dataParams = parameters;
    dataParams.append('eb_doctor_id', docParam.doctor_id);
    dataParams.append('eb_location_id', docParam.location_id);

    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/guarantee_letters/' + id + '/request_final', dataParams, { headers: authHeaderBearer() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new GuaranteeLetterService();